import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { adminAuthHeader } from "../../lib/adminAuth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Small admin button that sends a one-time "leave us a review" link to
 * the participant. Surfaced inside the patient/caregiver detail modals so
 * it's right next to the participant context.
 */
export default function SendReviewRequestButton({
  audience,
  record_id,
  disabled = false,
  study_id = null,
}) {
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    if (loading || disabled) return;
    if (
      !window.confirm(
        "Send this person a single-use email asking for a review? They can submit it once. You'll approve it before it goes live.",
      )
    ) {
      return;
    }
    setLoading(true);
    try {
      await axios.post(
        `${API}/admin/reviews/request`,
        { audience, record_id, study_id },
        { headers: adminAuthHeader() },
      );
      toast.success("Review request sent.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Couldn't send the request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      title={
        disabled
          ? "No email on file for this person."
          : "Send a one-time review request email."
      }
      className="inline-flex items-center gap-1.5 text-sm text-[var(--charcoal)] font-semibold hover:text-[var(--lime-dark)] disabled:opacity-50 disabled:cursor-not-allowed"
      data-testid={`send-review-request-${audience}-${record_id}`}
    >
      {loading ? (
        <Loader2 size={14} className="animate-spin" />
      ) : (
        <Send size={14} />
      )}
      Send review request
    </button>
  );
}
